<template>
  <div class="ai-visibility-progress-scale" :class="`ai-visibility-progress-scale--${tone}`">
    <div class="ai-visibility-progress-scale__track">
      <span class="ai-visibility-progress-scale__fill" :style="{ width: `${percentage}%` }"></span>
    </div>
    <div v-if="labels.length" class="ai-visibility-progress-scale__labels">
      <span v-for="label in labels" :key="label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressScale',
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 100,
    },
    labels: {
      type: Array,
      default () {
        return []
      },
    },
    tone: {
      type: String,
      default: 'accent',
    },
  },
  computed: {
    percentage () {
      if (!this.max) {
        return 0
      }
      return Math.max(0, Math.min(100, (this.value / this.max) * 100))
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-progress-scale__track {
  overflow: hidden;
  height: 10px;
  border-radius: 999px;
  background: var(--v-gray10Color-base);
}

.ai-visibility-progress-scale__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--v-profileAnchorColor-base);
}

.ai-visibility-progress-scale--success .ai-visibility-progress-scale__fill {
  background: var(--v-green7Color-base);
}

.ai-visibility-progress-scale--danger .ai-visibility-progress-scale__fill {
  background: #FF4040;
}

.ai-visibility-progress-scale__labels {
  display: flex;
  justify-content: space-between;
  color: var(--v-gray36Color-base);
  font-size: 11px;
  margin-top: 7px;

  span {
    font-size: 14px;
    font-weight: 500;
  }

}
</style>
